<template>
    <PopupRouterView :showLeftIcon="true" label="Part Good Receipt Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="partgoodreceipt"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="partGoodReceiptInput">


        <b-card header="Part Good Receipt" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="purchaseOrders" optionsLabel="purchaseOrderNumber" optionsKey="id" label-cols-lg="12" label="Purchase Order" id="fieldset-purchase-order" size="sm" :model.sync="model.purchaseOrderId" :isRequired="true" :state="validateState('purchaseOrderId')" :errorMessage="getErrorMessage(errorMessage.purchaseOrderId, 'purchaseOrderId')"   :selected="model.purchaseOrder != null ? model.purchaseOrder.purchaseOrderNumber : ''" @input="getPurchaseOrders" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPurchaseOrder" />
						<app-label label-cols-lg="12" size="sm" label="Purchase Order Number" :model="(model.purchaseOrder != null) ? model.purchaseOrder.purchaseOrderNumber : null"  />
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Part Good Receipt Number" :model="model.partGoodReceiptNumber" />
						<app-input-datepicker  id="fieldset-part-good-receipt-date" label-cols-lg="12"  label="Part Good Receipt Date" size="sm" :model.sync="model.partGoodReceiptDate" :isRequired="true" :state="validateState('partGoodReceiptDate')" :errorMessage="getErrorMessage(errorMessage.partGoodReceiptDate, 'partGoodReceiptDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" />
						<app-input-textbox id="fieldset-surat-jalan" label-cols-lg="12"  label="Surat Jalan" label-for="input-surat-jalan" size="sm" :model.sync="model.suratJalan" :isRequired="true" :state="validateState('suratJalan')" :errorMessage="getErrorMessage(errorMessage.suratJalan, 'suratJalan')"  @change="updateData" />
						<app-input-textarea id="fieldset-remark" label-cols-lg="12"  label="Remark" label-for="input-remark" size="sm" :model.sync="model.remark"  @change="updateData" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "PartGoodReceiptDetail"
			:bordered="true" :items="partGoodReceiptDetails" 
			:fields="fieldsPartGoodReceiptDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByPartGoodReceiptDetail" 
			:sort-desc.sync="sortDescPartGoodReceiptDetail" small responsive	
			@editButtonMethod="editRowDataPartGoodReceiptDetail"	
			@deleteButtonMethod="deleteRowDataPartGoodReceiptDetail"	
			@showPopupAddMethod="addDataPartGoodReceiptDetail()"	
			@showPopupUploadMethod="showPopupUploadPartGoodReceiptDetail()"
			@downloadMethod="downloadPartGoodReceiptDetail()"
			@addFromClipboardMethod="addFromClipboardPartGoodReceiptDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardPartGoodReceiptDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadPartGoodReceiptDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowPartGoodReceiptDetailFilter = !isShowPartGoodReceiptDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowPartGoodReceiptDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Purchase Order Detail Id">
					<v-select id="input-part-good-receipt-detail-purchase-order-detail-table" append-to-body label="qtyPo" :options="purchaseOrderDetails" :value="filterPartGoodReceiptDetail.purchaseOrderDetailId" :reduce="item => item.id" v-model="filterPartGoodReceiptDetail.purchaseOrderDetailId" @search="getPurchaseOrderDetails" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part Code">
					<v-select id="input-part-good-receipt-detail-part-table" append-to-body label="partNumber" :options="parts" :value="filterPartGoodReceiptDetail.partId" :reduce="item => item.id" v-model="filterPartGoodReceiptDetail.partId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Outstanding Before">
					<b-form-input id="input-part-good-receipt-detail-qty-outstanding-before-table" v-model="filterPartGoodReceiptDetail.qtyOutstandingBefore" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Received">
					<b-form-input id="input-part-good-receipt-detail-qty-received-table" v-model="filterPartGoodReceiptDetail.qtyReceived" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Actual">
					<b-form-input id="input-part-good-receipt-detail-qty-actual-table" v-model="filterPartGoodReceiptDetail.qtyActual" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Outstanding After">
					<b-form-input id="input-part-good-receipt-detail-qty-outstanding-after-table" v-model="filterPartGoodReceiptDetail.qtyOutstandingAfter" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Remark">
					<b-form-input id="input-part-good-receipt-detail-remark-table" v-model="filterPartGoodReceiptDetail.remark" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( partGoodReceiptDetailPageSize * (currentPartGoodReceiptDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(purchaseOrderDetail)="row">
				<app-input-combobox-autocomplete :options="purchaseOrderDetails" optionsLabel="qtyPo" optionsKey="id" :id="'input-part-good-receipt-detail-purchase-order-detail-' + row.index" label-cols-lg="12" label="Purchase Order Detail Id" size="sm" :model.sync="row.item.purchaseOrderDetailId"  @change="saveInputPartGoodReceiptDetail(row.item)" :selected="row.item.purchaseOrderDetail != null ? row.item.purchaseOrderDetail.qtyPo : ''"  @input="getPurchaseOrderDetails" :loading="isPurchaseOrderDetailComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-part-good-receipt-detail-part-' + row.index" label-cols-lg="12" label="Part Code" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputPartGoodReceiptDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(qtyOutstandingBefore)="row">
				<app-input-textbox :id="'input-part-good-receipt-detail-qty-outstanding-before-' + row.index" label-cols-lg="12" label="Qty Outstanding Before" size="sm" :model.sync="row.item.qtyOutstandingBefore" :state="validateState('qtyOutstandingBefore')" :errorMessage="getErrorMessage(errorMessage.qtyOutstandingBefore, 'qtyOutstandingBefore')"   @change="saveInputPartGoodReceiptDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyReceived)="row">
				<app-input-textbox :id="'input-part-good-receipt-detail-qty-received-' + row.index" label-cols-lg="12" label="Qty Received" size="sm" :model.sync="row.item.qtyReceived"   @change="saveInputPartGoodReceiptDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyActual)="row">
				<app-input-textbox :id="'input-part-good-receipt-detail-qty-actual-' + row.index" label-cols-lg="12" label="Qty Actual" size="sm" :model.sync="row.item.qtyActual"   @change="saveInputPartGoodReceiptDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyOutstandingAfter)="row">
				<app-input-textbox :id="'input-part-good-receipt-detail-qty-outstanding-after-' + row.index" label-cols-lg="12" label="Qty Outstanding After" size="sm" :model.sync="row.item.qtyOutstandingAfter"   @change="saveInputPartGoodReceiptDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(remark)="row">
				<app-input-textarea :id="'input-part-good-receipt-detail-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputPartGoodReceiptDetail(row.item)"   :nolabel="true" />
			</template>

								
			<template v-slot:form-add-detail>
				<PartGoodReceiptDetailInput 
					:model="modelPartGoodReceiptDetail"
					:openPopup="isShowPopupPartGoodReceiptDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPartGoodReceiptDetail"/>
			</template>
			<template v-slot:upload-detail>
					<PartGoodReceiptDetailUpload
					:openPopup="isShowPopupUploadPartGoodReceiptDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPartGoodReceiptDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentPartGoodReceiptDetailPage"
				:total-rows="totalPartGoodReceiptDetailRow"
				:per-page="partGoodReceiptDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>
		<app-table-input 
			title = "PartGoodReceiptCase"
			:bordered="true" :items="partGoodReceiptCases" 
			:fields="fieldsPartGoodReceiptCase" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByPartGoodReceiptCase" 
			:sort-desc.sync="sortDescPartGoodReceiptCase" small responsive	
			@editButtonMethod="editRowDataPartGoodReceiptCase"	
			@deleteButtonMethod="deleteRowDataPartGoodReceiptCase"	
			@showPopupAddMethod="addDataPartGoodReceiptCase()"	
			@showPopupUploadMethod="showPopupUploadPartGoodReceiptCase()"
			@downloadMethod="downloadPartGoodReceiptCase()"
			@addFromClipboardMethod="addFromClipboardPartGoodReceiptCase()"
			@replaceFromClipboardMethod="replaceFromClipboardPartGoodReceiptCase()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadPartGoodReceiptCase"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowPartGoodReceiptCaseFilter = !isShowPartGoodReceiptCaseFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowPartGoodReceiptCaseFilter">
				<b-th></b-th>
				<b-th stacked-heading="Purchase Order Detail">
					<v-select id="input-part-good-receipt-case-purchase-order-detail-table" append-to-body label="qtyPo" :options="purchaseOrderDetails" :value="filterPartGoodReceiptCase.purchaseOrderDetailId" :reduce="item => item.id" v-model="filterPartGoodReceiptCase.purchaseOrderDetailId" @search="getPurchaseOrderDetails" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select id="input-part-good-receipt-case-part-table" append-to-body label="partNumber" :options="parts" :value="filterPartGoodReceiptCase.partId" :reduce="item => item.id" v-model="filterPartGoodReceiptCase.partId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Supplier Case Number">
					<b-form-input id="input-part-good-receipt-case-supplier-case-number-table" v-model="filterPartGoodReceiptCase.supplierCaseNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Control Card">
					<v-select id="input-part-good-receipt-case-control-card-table" append-to-body label="controlCardNumber" :options="controlCards" :value="filterPartGoodReceiptCase.controlCardId" :reduce="item => item.id" v-model="filterPartGoodReceiptCase.controlCardId" @search="getControlCards" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Receive">
					<b-form-input id="input-part-good-receipt-case-qty-receive-table" v-model="filterPartGoodReceiptCase.qtyReceive" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Adjustment">
					<b-form-input id="input-part-good-receipt-case-qty-adjustment-table" v-model="filterPartGoodReceiptCase.qtyAdjustment" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Actual">
					<b-form-input id="input-part-good-receipt-case-qty-actual-table" v-model="filterPartGoodReceiptCase.qtyActual" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Remark">
					<b-form-input id="input-part-good-receipt-case-remark-table" v-model="filterPartGoodReceiptCase.remark" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Part Good Receipt Detail">
					<v-select id="input-part-good-receipt-case-part-good-receipt-detail-table" append-to-body label="part" :options="partGoodReceiptDetails" :value="filterPartGoodReceiptCase.partGoodReceiptDetailId" :reduce="item => item.id" v-model="filterPartGoodReceiptCase.partGoodReceiptDetailId" @search="getPartGoodReceiptDetails" :filterable ="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( partGoodReceiptCasePageSize * (currentPartGoodReceiptCasePage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(purchaseOrderDetail)="row">
				<app-input-combobox-autocomplete :options="purchaseOrderDetails" optionsLabel="qtyPo" optionsKey="id" :id="'input-part-good-receipt-case-purchase-order-detail-' + row.index" label-cols-lg="12" label="Purchase Order Detail" size="sm" :model.sync="row.item.purchaseOrderDetailId"  @change="saveInputPartGoodReceiptCase(row.item)" :selected="row.item.purchaseOrderDetail != null ? row.item.purchaseOrderDetail.qtyPo : ''"  @input="getPurchaseOrderDetails" :loading="isPurchaseOrderDetailComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-part-good-receipt-case-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputPartGoodReceiptCase(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(supplierCaseNumber)="row">
				<app-input-textbox :id="'input-part-good-receipt-case-supplier-case-number-' + row.index" label-cols-lg="12" label="Supplier Case Number" size="sm" :model.sync="row.item.supplierCaseNumber" :state="validateState('supplierCaseNumber')" :errorMessage="getErrorMessage(errorMessage.supplierCaseNumber, 'supplierCaseNumber')"   @change="saveInputPartGoodReceiptCase(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-part-good-receipt-case-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputPartGoodReceiptCase(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(qtyReceive)="row">
				<app-input-textbox :id="'input-part-good-receipt-case-qty-receive-' + row.index" label-cols-lg="12" label="Qty Receive" size="sm" :model.sync="row.item.qtyReceive" :state="validateState('qtyReceive')" :errorMessage="getErrorMessage(errorMessage.qtyReceive, 'qtyReceive')"   @change="saveInputPartGoodReceiptCase(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyAdjustment)="row">
				<app-input-textbox :id="'input-part-good-receipt-case-qty-adjustment-' + row.index" label-cols-lg="12" label="Qty Adjustment" size="sm" :model.sync="row.item.qtyAdjustment"   @change="saveInputPartGoodReceiptCase(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyActual)="row">
				<app-input-textbox :id="'input-part-good-receipt-case-qty-actual-' + row.index" label-cols-lg="12" label="Qty Actual" size="sm" :model.sync="row.item.qtyActual"   @change="saveInputPartGoodReceiptCase(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(remark)="row">
				<app-input-textarea :id="'input-part-good-receipt-case-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputPartGoodReceiptCase(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(partGoodReceiptDetail)="row">
				<app-input-combobox-autocomplete :options="partGoodReceiptDetails" optionsLabel="part" optionsKey="id" :id="'input-part-good-receipt-case-part-good-receipt-detail-' + row.index" label-cols-lg="12" label="Part Good Receipt Detail" size="sm" :model.sync="row.item.partGoodReceiptDetailId"  @change="saveInputPartGoodReceiptCase(row.item)" :selected="row.item.partGoodReceiptDetail != null ? row.item.partGoodReceiptDetail.part : ''"  @input="getPartGoodReceiptDetails" :loading="isPartGoodReceiptDetailComboLoading"    :nolabel="true" />
			</template>

								
			<template v-slot:form-add-detail>
				<PartGoodReceiptCaseInput 
					:model="modelPartGoodReceiptCase"
					:openPopup="isShowPopupPartGoodReceiptCase"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPartGoodReceiptCase"/>
			</template>
			<template v-slot:upload-detail>
					<PartGoodReceiptCaseUpload
					:openPopup="isShowPopupUploadPartGoodReceiptCase"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPartGoodReceiptCase"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentPartGoodReceiptCasePage"
				:total-rows="totalPartGoodReceiptCaseRow"
				:per-page="partGoodReceiptCasePageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PartGoodReceipt from '@/models/PartGoodReceipt/PartGoodReceipt';
import PartGoodReceiptList from '@/models/PartGoodReceipt/PartGoodReceiptList';
import PartGoodReceiptFilter from '@/filters/PartGoodReceipt/PartGoodReceiptFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';
import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PartGoodReceiptDetail from '@/models/PartGoodReceipt/PartGoodReceiptDetail';
import PartGoodReceiptDetailFilter from '@/filters/PartGoodReceipt/PartGoodReceiptDetailFilter';
import PartGoodReceiptCase from '@/models/PartGoodReceipt/PartGoodReceiptCase';
import PartGoodReceiptCaseFilter from '@/filters/PartGoodReceipt/PartGoodReceiptCaseFilter';
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PartGoodReceiptDetailInput from '@/views/PartGoodReceipt/PartGoodReceiptDetailInput';
import PartGoodReceiptDetailUpload from '@/views/PartGoodReceipt/PartGoodReceiptDetailUpload';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import PartGoodReceiptCaseInput from '@/views/PartGoodReceipt/PartGoodReceiptCaseInput';
import PartGoodReceiptCaseUpload from '@/views/PartGoodReceipt/PartGoodReceiptCaseUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		AppInputTextarea,
		PartGoodReceiptDetailInput,PartGoodReceiptDetailUpload,
		PartGoodReceiptCaseInput,PartGoodReceiptCaseUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			purchaseOrderId: {required},
			partGoodReceiptDate: {required},
			suratJalan: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				purchaseOrderId: { required : "Purchase Order is Required."},
				partGoodReceiptDate: { required : "Part Good Receipt Date is Required."},
				suratJalan: { required : "Surat Jalan is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsPartGoodReceiptDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"purchaseOrderDetail": { "class" : "th-purchase-order-detail first-child", "label" : "Purchase Order Detail Id", key: 'purchaseOrderDetail', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part Code", key: 'part', sortable: false}}, 
				{"qtyOutstandingBefore": { "class" : "th-qty-outstanding-before last-child", "label" : "Qty Outstanding Before", key: 'qtyOutstandingBefore', sortable: false}}, 
				{"qtyReceived": { "class" : "th-qty-received d-stack-none", "label" : "Qty Received", key: 'qtyReceived', sortable: false}}, 
				{"qtyActual": { "class" : "th-qty-actual d-stack-none", "label" : "Qty Actual", key: 'qtyActual', sortable: false}}, 
				{"qtyOutstandingAfter": { "class" : "th-qty-outstanding-after d-stack-none", "label" : "Qty Outstanding After", key: 'qtyOutstandingAfter', sortable: false}}, 
				{"remark": { "class" : "th-remark d-stack-none", "label" : "Remark", key: 'remark', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsPartGoodReceiptCase: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"purchaseOrderDetail": { "class" : "th-purchase-order-detail first-child", "label" : "Purchase Order Detail", key: 'purchaseOrderDetail', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part', sortable: false}}, 
				{"supplierCaseNumber": { "class" : "th-supplier-case-number last-child", "label" : "Supplier Case Number", key: 'supplierCaseNumber', sortable: false}}, 
				{"controlCard": { "class" : "th-control-card d-stack-none", "label" : "Control Card", key: 'controlCard', sortable: false}}, 
				{"qtyReceive": { "class" : "th-qty-receive d-stack-none", "label" : "Qty Receive", key: 'qtyReceive', sortable: false}}, 
				{"qtyAdjustment": { "class" : "th-qty-adjustment d-stack-none", "label" : "Qty Adjustment", key: 'qtyAdjustment', sortable: false}}, 
				{"qtyActual": { "class" : "th-qty-actual d-stack-none", "label" : "Qty Actual", key: 'qtyActual', sortable: false}}, 
				{"remark": { "class" : "th-remark d-stack-none", "label" : "Remark", key: 'remark', sortable: false}}, 
				{"partGoodReceiptDetail": { "class" : "th-part-good-receipt-detail d-stack-none", "label" : "Part Good Receipt Detail", key: 'partGoodReceiptDetail', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPartGoodReceiptDetail : {},
			isShowPopupPartGoodReceiptDetail : false,
			isShowPopupUploadPartGoodReceiptDetail : false,
			modelPartGoodReceiptCase : {},
			isShowPopupPartGoodReceiptCase : false,
			isShowPopupUploadPartGoodReceiptCase : false,
			filterPartGoodReceipt : null,
			currentPartGoodReceiptPage : 1,
			partGoodReceiptPageSize: 10,
			sortByPartGoodReceipt: '',
			sortDescPartGoodReceipt: '',
			filterPartGoodReceiptDetail : null,
			currentPartGoodReceiptDetailPage : 1,
			partGoodReceiptDetailPageSize: 10,
			sortByPartGoodReceiptDetail: '',
			sortDescPartGoodReceiptDetail: '',
			sortingByPartGoodReceiptDetail: [],
			partGoodReceiptDetails : [],
			partGoodReceiptDetailId : '',
			totalPartGoodReceiptDetailRow : 0,
			isShowPartGoodReceiptDetailFilter: false,
			isDownloadPartGoodReceiptDetail: false,
			filterPartGoodReceiptCase : null,
			currentPartGoodReceiptCasePage : 1,
			partGoodReceiptCasePageSize: 10,
			sortByPartGoodReceiptCase: '',
			sortDescPartGoodReceiptCase: '',
			sortingByPartGoodReceiptCase: [],
			partGoodReceiptCases : [],
			partGoodReceiptCaseId : '',
			totalPartGoodReceiptCaseRow : 0,
			isShowPartGoodReceiptCaseFilter: false,
			isDownloadPartGoodReceiptCase: false,
			purchaseOrderDetails: [],
			parts: [],
			controlCards: [],
			partGoodReceiptDetails: [],
			purchaseOrders: [],
			purchaseOrders: [],
			isPurchaseOrderComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPurchaseOrderComboLoading: false,
			isPartGoodReceiptComboLoading: false,
			isPurchaseOrderDetailComboLoading: false,
			isPartComboLoading: false,
			isControlCardComboLoading: false,
			isPartGoodReceiptDetailComboLoading: false,
		}
	},
	methods : {
		getPartGoodReceipt : async function(id) {
			this.isBusy = true;
			PartGoodReceipt.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.purchaseOrderId != null) {
					promises.push(
						this.getPurchaseOrder(this.model.purchaseOrderId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPartGoodReceipt = true;
			this.filterPartGoodReceipt.id = this.modelId;
			PartGoodReceipt.downloadDataDetail(this, this.filterPartGoodReceipt).then(result => {
				this.isDownloadPartGoodReceipt = false;
			}).catch(error => { this.isDownloadPartGoodReceipt = false; })
		},
		getPartGoodReceiptDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPartGoodReceiptDetail);
			if (this.modelId == null) return;
			filter.partGoodReceiptId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByPartGoodReceiptDetail != null) {
				this.sortingByPartGoodReceiptDetail[this.sortByPartGoodReceiptDetail] = this.sortDescPartGoodReceiptDetail;
			}
			let currentPage = (this.currentPartGoodReceiptDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPartGoodReceiptDetailRow + 1;
				let page = Math.ceil(totalData/this.partGoodReceiptDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.partGoodReceiptDetailPageSize = 0;
			// disable paging end
			PartGoodReceiptDetail.getList(this, filter, this.sortingByPartGoodReceiptDetail, currentPage , this.partGoodReceiptDetailPageSize).then(result => {
				this.currentPartGoodReceiptDetailPage = currentPage + 1;
				this.partGoodReceiptDetails = result.data;
				this.totalPartGoodReceiptDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getPartGoodReceiptCases : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPartGoodReceiptCase);
			if (this.modelId == null) return;
			filter.partGoodReceiptId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByPartGoodReceiptCase != null) {
				this.sortingByPartGoodReceiptCase[this.sortByPartGoodReceiptCase] = this.sortDescPartGoodReceiptCase;
			}
			let currentPage = (this.currentPartGoodReceiptCasePage - 1);
			if (isAddRow) {
				let totalData = this.totalPartGoodReceiptCaseRow + 1;
				let page = Math.ceil(totalData/this.partGoodReceiptCasePageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.partGoodReceiptCasePageSize = 0;
			// disable paging end
			PartGoodReceiptCase.getList(this, filter, this.sortingByPartGoodReceiptCase, currentPage , this.partGoodReceiptCasePageSize).then(result => {
				this.currentPartGoodReceiptCasePage = currentPage + 1;
				this.partGoodReceiptCases = result.data;
				this.totalPartGoodReceiptCaseRow = result.dataCount;
			}).catch(error => {});
		},
		getPartGoodReceipts : async function(input) {
			let filter = new PartGoodReceiptFilter();
			if (input != undefined) {
				filter.PurchaseOrder = input;
			}
			this.isPartGoodReceiptComboLoading = true;
			PartGoodReceipt.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partGoodReceipts = result.data
				}
				this.isPartGoodReceiptComboLoading = false;
			})
			.catch(error => {});
		},
		getPartGoodReceipts : async function(input) {
			let filter = new PartGoodReceiptFilter();
			if (input != undefined) {
				filter.purchaseOrder = input;
			}
			this.isPartGoodReceiptComboLoading = true;
			PartGoodReceipt.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partGoodReceipts = result.data
				}
				this.isPartGoodReceiptComboLoading = false;
			})
			.catch(error => {});
		},
		getPurchaseOrderDetails : async function(input) {
			let filter = new PurchaseOrderDetailFilter();
			if (input != undefined) {
				filter.qtyPo = input;
			}
			this.isPurchaseOrderDetailComboLoading = true;
			PurchaseOrderDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.purchaseOrderDetails = result.data
				}
				this.isPurchaseOrderDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getPartGoodReceiptDetails : async function(input) {
			let filter = new PartGoodReceiptDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isPartGoodReceiptDetailComboLoading = true;
			PartGoodReceiptDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partGoodReceiptDetails = result.data
				}
				this.isPartGoodReceiptDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getPurchaseOrders : async function(input) {
			let filter = new PurchaseOrderFilter();
			if (input != undefined) {
				filter.purchaseOrderNumber = input;
			}
			filter.fwDocStat = '0,1';
			filter.exactType.fwDocStat = '1';
			PurchaseOrder.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.purchaseOrders = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPurchaseOrderExecuted(item) {
			let _this = this;
			if(item == undefined || item == null) {
				this.model.purchaseOrderId = null;
				this.model.purchaseOrder = null;
				this.isBusy = true;
				PartGoodReceipt.resetDocument(this, this.model.id).then(result => {
					this.getPartGoodReceipt(this.model.id).then(result => {
						this.getPartGoodReceiptDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.purchaseOrderId = item.id;
				this.model.purchaseOrder = item;

				this.isBusy = true;
				PartGoodReceipt.copyFromDocument(this, 'purchaseorder', item.id, this.model.id).then(result => {
					this.getPartGoodReceipt(this.model.id).then(result => {
						this.getPartGoodReceiptDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedPurchaseOrder(item) {
			if(item) {
				var itemId = Number(item.id);
				if(this.model.purchaseOrderId == itemId) return;
			}

			if(this.partGoodReceiptDetails != null && this.partGoodReceiptDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Part Good Receipt akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.setSelectedPurchaseOrderExecuted(item);
					}
				})
				.catch(err => {})
			} else {
				this.setSelectedPurchaseOrderExecuted(item);
			}
		},
		getPurchaseOrder : async function(id) {
			PurchaseOrder.getData(this, id).then(result => {
				this.model.purchaseOrder = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.partGoodReceiptInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PartGoodReceipt.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'partgoodreceiptindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					PartGoodReceipt.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'partgoodreceiptindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartGoodReceipt.updateData(this, model, id)
					.catch((error) => {
						this.getPartGoodReceipt(id);
					});
				}
			});
		},
		onHidden() {
			this.getPartGoodReceipts();
		},
		addRowDataPartGoodReceiptDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.partGoodReceiptId =  this.modelId;
					PartGoodReceiptDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPartGoodReceiptDetails(true);
						this.isShowPopupPartGoodReceiptDetail = false;
					})
				} else {
					model.partGoodReceiptId =  this.modelId;
					PartGoodReceiptDetail.createDataDetail(this, model)
					.then(result => {
						this.getPartGoodReceiptDetails(true);
						this.isShowPopupPartGoodReceiptDetail = false;
					})
				}
			}
		},
		async editRowDataPartGoodReceiptDetail(id) {
			this.partGoodReceiptDetailId = id;
			this.isShowPopupPartGoodReceiptDetail = true; 
		},
		async deleteRowDataPartGoodReceiptDetail(id) {
			PartGoodReceiptDetail.deleteData(this, id).then(result => { this.getPartGoodReceiptDetails(); });
		},
		async resetDataPartGoodReceiptDetail() {
			this.partGoodReceiptDetailId = "";
			this.isShowPopupPartGoodReceiptDetail = true;
		},
		async addDataPartGoodReceiptDetail() {
			PartGoodReceiptDetail.createData(this, { partGoodReceiptId: this.modelId })
			.then(result => {
				this.getPartGoodReceiptDetails(true);
			})
		},
		async addFromClipboardPartGoodReceiptDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, partGoodReceiptId: this.modelId });
				});
				PartGoodReceiptDetail.addFromClipboard(this, parts).then(result => { this.getPartGoodReceiptDetails() });
			});
		},
		async replaceFromClipboardPartGoodReceiptDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, partGoodReceiptId: this.modelId });
				});
				PartGoodReceiptDetail.replaceFromClipboard(this, parts).then(result => { this.getPartGoodReceiptDetails() });
			});   
		},
		showPopupUploadPartGoodReceiptDetail() {
			if(this.partGoodReceiptDetails != null && this.partGoodReceiptDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PartGoodReceiptDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPartGoodReceiptDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPartGoodReceiptDetail = true;
			}
		},
		uploadDataPartGoodReceiptDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPartGoodReceiptDetail = false; 
		},
		downloadPartGoodReceiptDetail(modalEvent) {
			this.isDownloadPartGoodReceiptDetail = true;
			this.filterPartGoodReceiptDetail.partGoodReceiptId = this.modelId;
			PartGoodReceiptDetail.downloadDataDetail(this, this.filterPartGoodReceiptDetail).then(result => {
				this.isDownloadPartGoodReceiptDetail = false;
			}).catch(error => { this.isDownloadPartGoodReceiptDetail = false; })
		},
		saveInputPartGoodReceiptDetail(item) {
			if (this.partGoodReceipts != null && this.partGoodReceipts != undefined  && this.partGoodReceipts.length > 0) {
				item.partGoodReceipt = this.partGoodReceipts.find(q => q.id == item.partGoodReceiptId);
			}
			if (this.purchaseOrderDetails != null && this.purchaseOrderDetails != undefined  && this.purchaseOrderDetails.length > 0) {
				item.purchaseOrderDetail = this.purchaseOrderDetails.find(q => q.id == item.purchaseOrderDetailId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartGoodReceiptDetail.updateData(this, item, item.id);
				}
			});
		},
		addRowDataPartGoodReceiptCase(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.partGoodReceiptId =  this.modelId;
					PartGoodReceiptCase.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPartGoodReceiptCases(true);
						this.isShowPopupPartGoodReceiptCase = false;
					})
				} else {
					model.partGoodReceiptId =  this.modelId;
					PartGoodReceiptCase.createDataDetail(this, model)
					.then(result => {
						this.getPartGoodReceiptCases(true);
						this.isShowPopupPartGoodReceiptCase = false;
					})
				}
			}
		},
		async editRowDataPartGoodReceiptCase(id) {
			this.partGoodReceiptCaseId = id;
			this.isShowPopupPartGoodReceiptCase = true; 
		},
		async deleteRowDataPartGoodReceiptCase(id) {
			PartGoodReceiptCase.deleteData(this, id).then(result => { this.getPartGoodReceiptCases(); });
		},
		async resetDataPartGoodReceiptCase() {
			this.partGoodReceiptCaseId = "";
			this.isShowPopupPartGoodReceiptCase = true;
		},
		async addDataPartGoodReceiptCase() {
			PartGoodReceiptCase.createData(this, { partGoodReceiptId: this.modelId })
			.then(result => {
				this.getPartGoodReceiptCases(true);
			})
		},
		async addFromClipboardPartGoodReceiptCase() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, partGoodReceiptId: this.modelId });
				});
				PartGoodReceiptCase.addFromClipboard(this, parts).then(result => { this.getPartGoodReceiptCases() });
			});
		},
		async replaceFromClipboardPartGoodReceiptCase() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, partGoodReceiptId: this.modelId });
				});
				PartGoodReceiptCase.replaceFromClipboard(this, parts).then(result => { this.getPartGoodReceiptCases() });
			});   
		},
		showPopupUploadPartGoodReceiptCase() {
			if(this.partGoodReceiptCases != null && this.partGoodReceiptCases.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PartGoodReceiptCase akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPartGoodReceiptCase = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPartGoodReceiptCase = true;
			}
		},
		uploadDataPartGoodReceiptCase(modalEvent, newDatas) {
			this.isShowPopupUploadPartGoodReceiptCase = false; 
		},
		downloadPartGoodReceiptCase(modalEvent) {
			this.isDownloadPartGoodReceiptCase = true;
			this.filterPartGoodReceiptCase.partGoodReceiptId = this.modelId;
			PartGoodReceiptCase.downloadDataDetail(this, this.filterPartGoodReceiptCase).then(result => {
				this.isDownloadPartGoodReceiptCase = false;
			}).catch(error => { this.isDownloadPartGoodReceiptCase = false; })
		},
		saveInputPartGoodReceiptCase(item) {
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.partGoodReceiptDetails != null && this.partGoodReceiptDetails != undefined  && this.partGoodReceiptDetails.length > 0) {
				item.partGoodReceiptDetail = this.partGoodReceiptDetails.find(q => q.id == item.partGoodReceiptDetailId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartGoodReceiptCase.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPartGoodReceiptDetail = false; 
			this.isShowPopupPartGoodReceiptDetail = false; 
			if (modalType == 'PartGoodReceiptDetail') {
				this.getPartGoodReceiptDetails();
			}
			this.isShowPopupUploadPartGoodReceiptCase = false; 
			this.isShowPopupPartGoodReceiptCase = false; 
			if (modalType == 'PartGoodReceiptCase') {
				this.getPartGoodReceiptCases();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowPartGoodReceiptDetailFilter = true;
				//this.isShowPartGoodReceiptCaseFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterPartGoodReceipt = new PartGoodReceiptFilter();
		this.filterPartGoodReceiptDetail = new PartGoodReceiptDetailFilter();
		this.filterPartGoodReceiptCase = new PartGoodReceiptCaseFilter();
		//this.getPartGoodReceipts();
		//this.getPurchaseOrderDetails();
		//this.getParts();
		//this.getControlCards();
		//this.getPartGoodReceiptDetails();
		//this.getPurchaseOrders();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPartGoodReceipt(id);
			} else {
				this.modelId = id;
				this.getPartGoodReceipt(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortByPartGoodReceiptDetail : {
			handler: function() {
				this.getPartGoodReceiptDetails();
			}
		},
		sortDescPartGoodReceiptDetail: {
			handler: function() {
				this.getPartGoodReceiptDetails();
			}
		},
		currentPartGoodReceiptDetailPage: {
			handler: function() {
				this.getPartGoodReceiptDetails();
			}
		},
		partGoodReceiptDetailPageSize : {
			handler: function() {
				this.getPartGoodReceiptDetails();
			}
		},
		filterPartGoodReceiptDetail: {
			handler: function() {
				this.getPartGoodReceiptDetails();
			},
			deep: true,
		},
		sortByPartGoodReceiptCase : {
			handler: function() {
				this.getPartGoodReceiptCases();
			}
		},
		sortDescPartGoodReceiptCase: {
			handler: function() {
				this.getPartGoodReceiptCases();
			}
		},
		currentPartGoodReceiptCasePage: {
			handler: function() {
				this.getPartGoodReceiptCases();
			}
		},
		partGoodReceiptCasePageSize : {
			handler: function() {
				this.getPartGoodReceiptCases();
			}
		},
		filterPartGoodReceiptCase: {
			handler: function() {
				this.getPartGoodReceiptCases();
			},
			deep: true,
		},
	},
}
</script>
